import axios from "axios";
import JwtService from "./jwt.service";
import API_URL from "./config";

const ApiService = {
  setHeader() {
    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${JwtService.getToken()}`;
    axios.defaults.baseURL = API_URL;
  },
  setBaseUrl() {
    axios.defaults.baseURL = API_URL;
  },
  get(resource) {
    return axios.get(`${resource}`);
  },
  getWithParams(resource, data) {
    return axios.get(`${resource}`, { params: data });
  },
  post(resource, params) {
    return axios.post(`${resource}`, params);
  },

  put(resource, params) {
    return axios.put(`${resource}`, params);
  },

  patch(resource, data) {
    return axios.patch(`${resource}`, data);
  },

  delete(resource) {
    return axios.delete(resource);
  }
};

export default ApiService;
